module.exports = __webpack_public_path__ + "static/img/钙化.5698038.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/钙化.png
// module id = NX/s
// module chunks = 1